import styleSheet from "./style.module.scss";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrbitDetails,
  setAdminStuff,
  setHoverPlanet,
  setMaps,
  setSelectOrbit,
} from "../../../../feature/orbit-slice";
import { orbitParamValue } from "../../../../utils/helper";
import OrbitDetails from "./orbit-details";
import SyIcon from "../../../../shared/components/sy-icon";

type Props = {};

const OrbitScreen = (props: Props) => {
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(orbitParamValue(searchParams));
  const dispatch = useDispatch();
  const orbitInfo = useSelector(getOrbitDetails);
  const navigate = useNavigate();

  const navPlanetDetails = (orbitId: any, planetId: any) => {
    const timeout = setTimeout(() => {
      navigate({
        pathname: `/view/planet/${orbitId}/${planetId}`,
        search: `?fr=${params.fr}`,
      });
    }, 200);
    return () => clearTimeout(timeout);
  };

    const back = () => {
      // dispatch(setSelectOrbit(null));
      // dispatch(setMaps(0));
      // dispatch(setAdminStuff(null));
      // dispatch(setHoverPlanet(null));
      navigate("/");
    };
  
  useEffect(() => {
    console.log('oin')
    if (!orbitInfo.selectOrbit) {
      dispatch(setMaps(Number(params?.maps)));
      dispatch(setSelectOrbit(Number(params.selectedOrbit)));
    } else {
      navigate({
        pathname: "/orbit",
        search: `?id=${orbitInfo.selectOrbit}&map=${orbitInfo.maps}&fr=${params.fr}`,
      });
    }

    
  }, [orbitInfo.selectOrbit]);



  return (
    <div className={`${styleSheet.home_container} sy-scroll-y  mt-5 px-3`}>
      <div className=" pt-3">
      <SyIcon
                  className={"text-white pe-1  pointer"}
                  name={"arrow_back_ios_new"}
                  iconType="symbols"
                  iconStyle="outlined"
                  onClick={back}
                />
      </div>
         
      {orbitInfo.selectOrbit && (
        <OrbitDetails navPlanetDetails={navPlanetDetails} />
      )}
    </div>
  );
};
export default OrbitScreen;
